import {TabsTemplate} from 'components/Common/Tabs/Template';
import {withProps} from 'recompose';

export default withProps({
  tabs: {
    index: '儲值卡列表',
  },
  title: '儲值及使用量查詢',
})(TabsTemplate);
